export default function IndexSection() {
  const indexItems = [
    { id: 1, letter: 'A', name: '暗夜守护者', category: '悬疑推理' },
    { id: 2, letter: 'B', name: '百炼成神', category: '玄幻修仙' },
    { id: 3, letter: 'C', name: '沧元图', category: '东方玄幻' },
    { id: 4, letter: 'D', name: '斗罗大陆', category: '热血战斗' },
    { id: 5, letter: 'F', name: '凡人修仙传', category: '修仙武侠' },
    { id: 6, letter: 'J', name: '绝世战魂', category: '热血战斗' },
    { id: 7, letter: 'L', name: '灵笼', category: '末日科幻' },
    { id: 8, letter: 'S', name: '少年歌行', category: '武侠江湖' },
    { id: 9, letter: 'W', name: '完美世界', category: '东方玄幻' },
  ];

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            动漫索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按字母索引快速查找51动漫收录的国产动漫作品
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#index"
                className="group flex items-center gap-4 p-3.5 md:p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-100/70 rounded-xl text-primary-600 font-heading text-lg md:text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                  {item.letter}
                </div>
                <div className="min-w-0">
                  <div className="font-heading text-sm md:text-base text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.category}</div>
                </div>
              </a>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#index"
              className="inline-flex items-center gap-2 px-6 py-2.5 border-2 border-primary-200 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-arrow-down-s-line text-lg"></i>
              查看全部动漫索引
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}